export default "__VITE_ASSET__CLBdXil0__"